import { render, staticRenderFns } from "./ProductFormModal.vue?vue&type=template&id=ade013ce&"
import script from "./ProductFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormModal.vue?vue&type=style&index=0&id=ade013ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports